export class Table {
  constructor(difference) {
    this.styleId = 1
    this.width = 410
    this.height = 400
    this.top = 10
    this.left = 10
    this.innerElement = "cxTable"
    this.rotate = 0
    this.showHeader = true //显示表头
    this.isShowSerialNumber = false // 是否显示序号
    this.headerBgColor = "rgba(255, 255, 255, 0.1)"
    this.headerHeight = 45 // 表头行高
    this.headerFontFamily = "sans-serif"
    this.headerFontSize = 14
    this.headerFontWeight = "400"
    this.headerFontColor = "rgba(255, 255, 255, 1)"
    this.showColsType = "all" //"all": 全部显示；"customize"：自定义展示
    this.showCols = 5 // 显示列数
    this.colsWidthType = "default" // "default": 平均宽度;"auto":自定义宽度
    this.autoWidthType = "wrap" // "wrap":换行显示；"float"：鼠标悬浮显示
    this.showRowsType = "all" //"all": 全部显示；"customize"：自定义展示
    this.showRows = 5 // 显示行数
    this.rowsHeight = 70 // 行高
    // 奇行样式
    this.oddBgColorType = "纯色" // "纯色"、"线性渐变"、"径向渐变"
    this.oddBgColor = "rgba(0,4,58,0)"
    this.oddBgStartColor = "rgba(0,4,58,0)"
    this.oddBgEndColor = "rgba(19,32,148,0)"
    // 偶行样式
    this.evenBgColorType = "纯色" // "纯色"、"线性渐变"、"径向渐变"
    this.evenBgColor = "rgba(0,4,58,0)"
    this.evenBgStartColor = "rgba(0,4,58,0.3)"
    this.evenBgEndColor = "rgba(19,32,148,0)"
    // 默认行字体样式
    this.defaultFontFamily = "sans-serif"
    this.defaultFontSize = 16
    this.defaultFontWeight = "400"
    this.defaultFontColor = "rgba(255, 255, 255, 0.8)"
    this.specialRows = [
      // 特殊行配置
      // {
      //   rowIndex: 1,
      //   specialBgColorType: "纯色", // "纯色"、"线性渐变"、"径向渐变"
      //   specialBgColor: "rgba(0,58,41,0.18)",
      //   specialBgStartColor: "rgba(0,4,58,0)",
      //   specialBgEndColor: "rgba(19,32,148,0.32)",
      //   specialFontFamily: "sans-serif",
      //   specialFontSize: 16,
      //   specialFontWeight: 400,
      //   specialFontColor: "rgb(104,227,105)"
      // },
      // {
      //   rowIndex: 3,
      //   specialBgColorType: "纯色", // "纯色"、"线性渐变"、"径向渐变"
      //   specialBgColor: "rgba(0,4,58,0)",
      //   specialBgStartColor: "rgba(46,0,58,0)",
      //   specialBgEndColor: "rgba(19,32,148,0.12)",
      //   specialFontFamily: "sans-serif",
      //   specialFontSize: 16,
      //   specialFontWeight: 400,
      //   specialFontColor: "rgba(255,255,255,0.8)"
      // }
    ]
    this.headerData = ["学号", "姓名", "成绩"]
    this.listData = [
      ["12334", "张萌萌", "99"],
      ["12225", "王明玉", "98"],
      ["13545", "王建国", "92"],
      ["13665", "欧菲菲", "90"],
      ["16542", "郭山闪", "85"],
      ["19954", "邓华丽", "85"]
    ]
    this.listOtherData = [{}, {}, {}, {}, {}] // 表格额外内容，需要和listData的长度保持一致，一般存放表格整行点击跳转地址等参数
    this.colsWidthList = [33, 33, 33]
    this.overflowText = "single" // wrap: 换行展示、single：单行省略
    this.showPagination = false //显示分页
    // 选中单元格样式
    this.selectCellBgColor = ""
    this.selectCellFontFamily = "default"
    this.selectCellFontSize = 16
    this.selectCellFontWeight = "400"
    this.selectCellFontColor = "rgba(0, 0, 0, 0.8)"
    this.turnOnScroll = false // 开启滚动
    this.scrollAutoSelf = false // 开启自动或者手动滚动
    this.hoverStopScroll = false // 鼠标移入停止滚动
    this.waitTime = 1 // 单步停止等待时间
    this.updateTimer = null // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.selectPageQuery = false //开启动态参数
    this.openBlankPage = true //跳转至新页面
    this.textAlign = "center"
    this.headerTextAlign = "center"
    this.rankName = "排名"
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
